module.exports = __webpack_public_path__ + "static/b2-0a5d1aec18f82d1f4ea5d8ba718a2aa8.jpg";